import WidgetEventListPagingResultModelBase from '../_generated/modelBases/widget-event-list-paging-result-model-base';

export default class WidgetEventListPagingResultModel extends WidgetEventListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
